import React, { useEffect } from "react";
import { Spinner, Form } from "react-bootstrap";
import {
  usePageCategoryShowQuery,
  useUpdatePositionPagesMutation,
} from "../../../graphql/pageCategory.hooks";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Formik, Form as FormikForm, Field, FieldArray } from "formik";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";

interface PageOrder {
  id: number;
  orderMePage: number;
  orderMeQr: number;
  pageId: number;
  isLanding: boolean;
}

interface IOrderValues {
  pages: PageOrder[];
}

export const ShowCategory = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const lng = useGetUrlLocale();
  const { data: category, loading: categoryLoading } = usePageCategoryShowQuery(
    { variables: { pageCategory: +categoryId }, fetchPolicy: "network-only" }
  );
  const [updatePositionPages, { loading: loadingUpdatePositionPages }] =
    useUpdatePositionPagesMutation();

  useEffect(() => {
    document.title = "View Category";
  }, []);

  const backToList = () => {
    navigate("/page/category");
  };

  const handleSubmit = (values: IOrderValues) => {
    const pagesPriority = values.pages.map((item) => ({
      pagePageCategoryId: item.id,
      priorityMeQr: item.orderMeQr,
      priority: item.orderMePage,
      isLanding: item.isLanding,
    }));
    updatePositionPages({ variables: { pagesPriority } });
  };

  if (categoryLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const initialValues: IOrderValues = {
    pages: category.pageCategoryShow.pagePageCategories.map(
      ({ id, position, positionMeQr, page, isLanding }) => ({
        id,
        orderMePage: position || 0,
        orderMeQr: positionMeQr || 0,
        pageId: page.id,
        isLanding: isLanding ? true : false,
      })
    ),
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>Page Category</h1>
          <p className="text-nowrap fs-4">
            Title: {category.pageCategoryShow.title} Id:{" "}
            {category.pageCategoryShow.id}
          </p>
        </div>
      </div>
      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values }) => (
            <FormikForm className="w-100">
              <table className="col-11 mb-5 m-auto">
                <thead>
                  <tr>
                    <th className="d-none d-md-block">Id</th>
                    <th>Title</th>
                    <th className="text-center">Actions</th>
                    <th className="text-center">Add To Landing</th>
                    <th className="text-center">Me-Page Order</th>
                    <th className="text-center">Me-QR Order</th>
                  </tr>
                </thead>
                <tbody>
                  <FieldArray name="pages">
                    {() =>
                      values.pages.map((page, index) => (
                        <tr key={page.id} style={{ lineHeight: "2" }}>
                          <td className="d-none d-md-table-cell">{page.id}</td>
                          <td>
                            {
                              category.pageCategoryShow.pagePageCategories.find(
                                (p) => p.id === page.id
                              ).page.title
                            }
                          </td>
                          <td className="text-center">
                            <Link
                              to={`${process.env.REACT_APP_CONSTRUCTOR_URL}${lng}/${page.pageId}`}
                              className="text-primary me-4"
                              style={{ textDecoration: "none" }}
                            >
                              Show
                            </Link>
                            <Link
                              to={`${lng}/page/${page.pageId}/edit`}
                              className="text-primary"
                              style={{ textDecoration: "none" }}
                            >
                              Settings
                            </Link>
                          </td>
                          <td>
                            <Field
                              name={`pages[${index}].isLanding`}
                              type="checkbox"
                              placeholder="isLanding"
                              as={Form.Check}
                              className="d-flex justify-content-center"
                            />
                          </td>
                          <td>
                            <Field
                              name={`pages[${index}].orderMePage`}
                              type="number"
                              placeholder="Order"
                              as={Form.Control}
                              min="0"
                              style={{ maxWidth: 100 }}
                              className="m-auto"
                            />
                          </td>
                          <td>
                            <Field
                              name={`pages[${index}].orderMeQr`}
                              type="number"
                              placeholder="Order"
                              as={Form.Control}
                              min="0"
                              style={{ maxWidth: 100 }}
                              className="m-auto"
                            />
                          </td>
                        </tr>
                      ))
                    }
                  </FieldArray>
                  {!category.pageCategoryShow.pagePageCategories.length && (
                    <p className="mt-3">No Pages Found</p>
                  )}
                  <tr></tr>
                </tbody>
              </table>
              <div className="d-flex flex-column flex-md-row justify-content-between col-11 col-md-8 m-auto">
                <button
                  onClick={backToList}
                  className="btn btn-primary text-white col-12 col-md-4 me-md-4 mb-2 mb-md-0"
                >
                  Back To List
                </button>
                <button
                  type="submit"
                  className="btn btn-primary text-white col-12 col-md-4 me-md-4 mb-2 mb-md-0"
                  disabled={loadingUpdatePositionPages}
                >
                  Save {loadingUpdatePositionPages && <Spinner />}
                </button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};
